var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fip"},[_c('div',{class:[_vm.isNum?'num':'']},_vm._l((_vm.arr),function(item,index){return _c('div',{key:index},[_vm._v(" "+_vm._s(_vm.year=='年'?item+'年':item)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }